










































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Button, ButtonGroup, Card, Icon } from '@alpha/ink'
import Toast from '@/components/Toast.vue'
import DropdownButton from '@/components/DropdownButton.vue'
import AddTestModal from '@/components/AddTest/AddTestModal.vue'
import * as db from '@shared/types/database'
import store from '@/store'
import { PresetTestMessages } from '@/store/modules/notification-store-module'
import { forceString } from '@/utilities/alpha'
import analytics from '@/analytics'
import api from '@/api'
import * as graph from '@shared/types/graphql'
import ShareLinkMenu from './ShareLinkMenu.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import { exportChartsToZip } from '@/utilities/highcharts-export'
import { detectIE } from '@/utilities/browser'
import { VUE_APP_LEGACY_API } from '@/config'
import { testURL } from '@/utilities/test-helpers'
import { SelectedTemplate } from '@/types/frontend'

@Component({
  components: {
    Button,
    ButtonGroup,
    DropdownButton,
    AddTestModal,
    Toast,
    ShareLinkMenu,
    LoadingIndicator,
    Card,
    Icon
  }
})
export default class TestDetailsHeaderActions extends Vue {
  @Prop({ required: true }) readonly status!: db.TestStatus
  @Prop({ required: true }) readonly test!: db.Test
  @Prop({ default: false }) readonly templateInputsValidated!: boolean
  @Prop({ default: false }) readonly livechartsEnabled?: boolean
  @Prop({ default: false }) readonly isAdmin?: boolean
  @Prop({ required: true }) readonly canClone!: boolean
  @Prop({ default: true }) readonly canAddToQueue!: boolean
  @Prop({ default: true }) readonly showDropdownOptions!: boolean

  showAddTest: boolean = false
  selectedTemplate: SelectedTemplate = null
  initialTest: db.Test | null = null
  loading: boolean = false
  showDeletePrompt: boolean = false
  showErrorMessage: boolean = false
  exporting: boolean = false
  template: graph.Template | null = null
  cloning = false
  deleting = false
  keepKebabDropdownOpen = false

  async clone () {
    if (this.cloning) return

    this.cloning = true
    this.keepKebabDropdownOpen = true
    analytics.track('Follow Up Test - Clone Existing')

    // Prep test-creation-store
    const workspaceId = store.state.workspace.workspace.id
    await store.dispatch.testCreation.loadWorkspace(workspaceId)
    await store.dispatch.testCreation.setProjectForClonedTest(forceString(this.test.id))
    const allPrototypes = this.test.payload.prototypes
    const nonURLPrototypes = Object.keys(allPrototypes).reduce((acc, id) => {
      const prototype = allPrototypes[id]
      if (prototype.asset_type !== 'url') {
        acc[id] = prototype
      }
      return acc
    }, {} as Record<string, db.Prototype>)
    await store.commit.testCreation.setPrototypes(nonURLPrototypes)

    // Create
    if (this.newTestExperienceEnabled) {
      // Clone test
      const newTest = await store.dispatch.testCreation.cloneTest(this.test)

      // TODO: this is lame, successData doesn't have all the data we need, and we dont
      // have an api method to get just 1 test, so updating the whole workspace...
      // Lets fix this!
      const updatedWorkspace = await api.getWorkspaceWithTests(workspaceId)
      if (updatedWorkspace) {
        await store.dispatch.workspace.setWorkspace(updatedWorkspace)
      } else {
        console.error('Missing workspace from response')
      }

      const url = testURL(
        store.state.testCreation.workspace!.id,
        newTest.id,
        store.state.testCreation.projectId
      )
      this.$router.push(url)
    } else {
      // Load add test modal with pre-filled fields

      this.initialTest = this.test

      if (this.initialTest.payload.testType === 'Template') {
        const template = await api.getTemplateById(this.initialTest.payload.testTemplateId!.toString(), this.accountId!)
        const templateValues = this.initialTest.payload.templateFieldValues ?? null
        this.selectedTemplate = { template, templateValues }
      }

      this.showAddTest = true
    }
    this.cloning = false
    this.keepKebabDropdownOpen = false
  }

  get newTestExperienceEnabled () {
    return store.getters.feature.hasFeature('newTestExperience')
  }

  get accountId () {
    return store.state.testCreation.workspace?.accountId
  }

  exportCharts () {
    exportChartsToZip(store)
  }

  get showCreateReportButton () {
    return this.showCompletedState && !this.livechartsEnabled
  }

  get showCompletedState () {
    return this.status === db.TestStatus.Complete || (this.status === db.TestStatus.InProgress && this.isAdmin)
  }

  get showCSVExport () {
    return this.showCompletedState && this.livechartsEnabled
  }

  get chartsLoaded () {
    return store.state.livechartRefs.chartsLoaded
  }

  get canDelete () {
    return [db.TestStatus.Draft, db.TestStatus.InReview].includes(this.status)
  }

  createSharedReports () {
    const routeData = this.$router.resolve({ path: `/${this.$router.currentRoute.params.workspaceId}/${this.$router.currentRoute.params.testId}/SharePreview/` })
    window.open(routeData.href, '_blank')
  }

  openQueue () {
    this.$router.push({ name: 'queue', params: { testId: this.$route.params.testId } })
  }

  closeDeletePrompt () {
    this.showDeletePrompt = false
  }

  showDeleteModal () {
    this.showDeletePrompt = true
  }

  followUpClicked () {
    analytics.track('Create A Follow-up ')
  }

  get isIE () {
    return detectIE()
  }

  async createDocx () {
    if (this.isIE) return
    const { toDocBlob, downloadBlob, exportDataFromStore } = await import('@/utilities/export-docx')
    try {
      this.exporting = true
      const audience = store.getters.workspace.getAudienceById(this.test.payload.segment!.id)!
      const { payload, createdAt } = this.test
      const { title, completedAt, testType } = payload
      const testInfo = {
        title: title ?? '',
        completedAt: completedAt as number,
        type: testType,
        audience: { _id: audience._id!, payload: audience.payload },
        createdAt,
        reportBy: `${store.state.user.authenticatedUser!.firstName} ${store.state.user.authenticatedUser!.lastName}`,
        createdBy: this.test.created_by.name
      }
      const exportData = await exportDataFromStore(store, testInfo)
      const blob = await toDocBlob(exportData, store)
      const filename = `${store.state.workspace.workspace.name.replace(/ /g, '-')}_${this.test.id}.docx`
      downloadBlob(document, window, blob, filename)
      analytics.track(`Export Docx (livecharts) - ${filename}`)
      this.toast = 'Download Started'
    } catch (error) {
      console.error(error)
      this.toast = 'Error exporting Docx'
    }

    this.exporting = false
  }

  async createCsv () {
    this.exporting = true
    const response = await api.createCsv(store.state.workspace.workspace.id, store.getters.survey.surveyId)
    if (response?.status) {
      window.open(response.file, '_blank')
      this.toast = 'CSV downloaded!'
    } else {
      this.toast = response?.error || false
    }
    this.exporting = false
  }

  async createScreenerCsv () {
    this.exporting = true
    const response = await api.createScreenerCsv(this.$route.params.workspaceId, this.$route.params.testId)
    if (response?.status) {
      window.open(response.file, '_blank')
      this.toast = 'Screener CSV downloaded!'
    } else {
      this.toast = response?.error || false
    }
    this.exporting = false
  }

  set toast (value: string | false) {
    store.dispatch.notification.setMessage(value)
  }

  get toast () {
    return store.state.notification.message
  }

  async mounted () {
    if (this.test.payload.testType === 'Template') {
      const templateId = `${this.test.payload.testTemplateId!}`
      const accountId = store.state.workspace.accountId!
      this.template = await api.getTemplateById(templateId, accountId)
    }
  }

  async changeTestStatus (status: db.TestStatus) {
    if (this.test.payload.testType === 'Template' && status === db.TestStatus.InReview) {
      await this.$emit('validateTemplate')
      if (!this.templateInputsValidated) {
        this.showErrorMessage = true
        return
      } else {
        this.showErrorMessage = false
      }
    }
    const { workspaceId, testId } = this.$route.params
    const test = {
      status
    }
    this.loading = true
    const res = await store.dispatch.workspace.updateTest({ test, workspaceId, testId })
    const message = res ? PresetTestMessages.updateSuccess : PresetTestMessages.updateFail
    store.dispatch.notification.setMessage(message)
    this.loading = false
  }

  async deleteTest () {
    this.deleting = true
    const { workspaceId, testId } = this.$route.params
    const res = await store.dispatch.workspace.deleteTest({ workspaceId, testId })
    this.deleting = false
    if (res) {
      this.$router.push({ name: 'tests' })
    } else {
      store.dispatch.notification.setMessage(PresetTestMessages.updateFail)
    }
  }

  get testAdminURL () {
    const workspaceId = this.$router.currentRoute.params.workspaceId
    const mgtLink = VUE_APP_LEGACY_API
    return `${mgtLink}/${workspaceId}/${this.test.id}/update`
  }
}
